import { Navigate, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import logoUrl from '../assets/loot-studios-logo.png';
import { loginUrl, useMe } from '../auth.tsx';
import { Loading } from '../components/ui.tsx';
import { LanguageSwitch } from '../layout.tsx';

export function LoginPage() {
  const { t } = useTranslation();
  const { error, returnTo } = useSearch({ from: '/login' });
  const me = useMe();
  // Nunca volta para a própria tela de login depois de entrar.
  const target = returnTo && !returnTo.startsWith('/login') ? returnTo : '/';

  if (me.isPending)
    return (
      <div className="p-8">
        <Loading />
      </div>
    );
  if (me.data) return <Navigate to={target} />;

  return (
    <div className="flex min-h-dvh items-center justify-center px-4 py-10">
      <div className="flex w-full max-w-sm flex-col gap-6 rounded-lg border border-rule bg-sheet p-8 shadow-sm">
        <div className="flex flex-col gap-1">
          <img src={logoUrl} alt="Loot Studios" className="mb-3 w-40" />
          <h1 className="text-xl font-semibold">{t('auth.title')}</h1>
          <p className="text-sm text-muted">{t('auth.subtitle')}</p>
        </div>
        {error && (
          <p
            role="alert"
            className="rounded-lg border border-danger/30 bg-danger/5 p-3 text-sm text-danger"
          >
            {t(`auth.errors.${error}`, { defaultValue: t('auth.errors.provider_error') })}
          </p>
        )}
        <a
          href={loginUrl(target)}
          className="rounded-md bg-accent px-4 py-2.5 text-center text-sm font-medium text-on-accent shadow-sm hover:opacity-90"
        >
          {t('auth.signIn')}
        </a>
        <p className="text-xs text-muted">{t('auth.help')}</p>
        <LanguageSwitch />
      </div>
    </div>
  );
}
